import React from 'react';
import ArticlesStockAmountSelectProperties, { ArticleAmountItem } from "./ArticlesStockAmountSelectProperties";
import { useI18nContext } from "../../../contexts/I18nContext";
import { useStyles } from "./ArticlesStockAmountSelect.style";
import clsx from "clsx";
import { useCommonStyles } from "../../../ui_components/common/CommonStyles.style";
import ArticleStockSelect from "../ArticleStockSelect/ArticleStockSelect";
import ArticleStockResponse from "../../../model/articleDelivery/ArticleStockResponse";
import TextInput from "../../../ui_components/TextInput/TextInput";
import TextInputType from "../../../ui_components/TextInput/TextInputType";
import Button from "../../../ui_components/Button/Button";
import ButtonType from "../../../ui_components/Button/ButtonType";
import DeleteIcon from "@mui/icons-material/Delete";

const ArticlesStockAmountSelect: React.FC<ArticlesStockAmountSelectProperties> = ({
    onChange,
    disabled = false,
    required = false,
    fullWidth = false,
    className = '',
    items = [],
    label = 'Artículos',
    entityId = '',
    onAddItem,
    onRemoveItem,
}) => {
    const classes = useStyles();
    const commonClasses = useCommonStyles();
    const i18n = useI18nContext();
    const containerClasses = clsx(classes.container, className, fullWidth && commonClasses.fullWidth);

    const handleArticleStockChange = (item: ArticleAmountItem) => (newArticle?: ArticleStockResponse) => {
        const updatedItems = items.map(i => 
            i.id === item.id 
                ? { ...i, article: newArticle, articleError: undefined }
                : i
        );
        onChange(updatedItems);
    };

    const handleAmountChange = (item: ArticleAmountItem) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newAmount = +event.target.value;
        const updatedItems = items.map(i => 
            i.id === item.id 
                ? { ...i, amount: newAmount, amountError: undefined }
                : i
        );
        onChange(updatedItems);
    };

    const handleRemoveItem = (id: string) => {
        if (onRemoveItem) {
            onRemoveItem(id);
        } else {
            const updatedItems = items.filter(i => i.id !== id);
            onChange(updatedItems);
        }
    };

    const handleAddItem = () => {
        if (onAddItem) {
            onAddItem();
        } else {
            const newItem: ArticleAmountItem = {
                id: `${Date.now()}-${Math.random()}`,
                article: undefined,
                amount: undefined,
                articleError: undefined,
                amountError: undefined
            };
            onChange([...items, newItem]);
        }
    };

    return (
        <div className={clsx(containerClasses, { [classes.disabled]: disabled })}>
            <div className={classes.label}>{label + `${required ? '*' : ''}`}</div>
            
            <div className={classes.add_btn_container}>
                <Button
                    text={'Adicionar'}
                    className={classes.add_button}
                    onClick={handleAddItem}
                    type={ButtonType.PRIMARY}
                    disabled={disabled}
                    startIcon={<span>+</span>}
                />
            </div>
            <div className={classes.items_container}>
                {items.map((item) => (
                    <div key={item.id} className={classes.item_row}>
                        <ArticleStockSelect
                            fullWidth
                            label={'Artículo'}
                            className={classes.article_select}
                            error={item.articleError ? i18n.translate(item.articleError) : undefined}
                            entityId={entityId}
                            selected={item.article}
                            onChange={handleArticleStockChange(item)}
                            disabled={disabled}
                        />
                        <TextInput
                            type={TextInputType.NUMBER}
                            value={item.amount || ''}
                            onChange={handleAmountChange(item)}
                            label={i18n.translate("QUANTITY")}
                            error={item.amountError ? i18n.translate(item.amountError) : undefined}
                            className={classes.amount_input}
                            fullWidth
                            disabled={disabled}
                        />
                        <Button
                            onClick={() => handleRemoveItem(item.id)}
                            className={classes.delete_button}
                            type={ButtonType.DANGER}
                            tooltip={"Eliminar"}
                            endIcon={<DeleteIcon />}
                        >
                        </Button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ArticlesStockAmountSelect;
